import gaAsync from '@/js/common/Domain/Service/gaAsync';
import '@/js/desktop/components/account';
import '@/js/desktop/components/banners';
import '@/js/common/components/virtualPhone/virtualPhone';
import '@/js/desktop/components/intercomChat/intercomChat';
import '@/js/common/Service/mindBoxService/MindBoxServiceDesktop';
import '@/js/desktop/components/droppedOrderBanner';

gaAsync(()=>{});
